import { render, staticRenderFns } from "./PageDiscountsUpdate.vue?vue&type=template&id=b63134b6&scoped=true&"
import script from "./PageDiscountsUpdate.vue?vue&type=script&lang=ts&"
export * from "./PageDiscountsUpdate.vue?vue&type=script&lang=ts&"
import style0 from "./PageDiscountsUpdate.vue?vue&type=style&index=0&id=b63134b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63134b6",
  null
  
)

export default component.exports